import avatar1 from "url:../avatars/1.png";
import avatar2 from "url:../avatars/2.png";
import avatar3 from "url:../avatars/3.png";
import avatar4 from "url:../avatars/4.png";
import avatar5 from "url:../avatars/5.png";
import avatar6 from "url:../avatars/6.png";
import avatar7 from "url:../avatars/7.png";
import avatar8 from "url:../avatars/8.png";
import avatar9 from "url:../avatars/9.png";
import avatar10 from "url:../avatars/10.png";
import avatar11 from "url:../avatars/11.png";

import bg1 from 'url:../images/wallpapers/19.jpg';
import bg2 from 'url:../images/wallpapers/24.jpg';
import bg3 from 'url:../images/wallpapers/26.jpg';
import bg4 from 'url:../images/wallpapers/44.jpg';
import bg5 from 'url:../images/wallpapers/213.jpg';
import me from 'url:../images/Kenny_profile_pic.jpg';
import me2 from 'url:../images/dev.jpg';
import dev from 'url:../images/dev.jpg';
import NY from 'url:../images/landscape_of_NYCjpg.jpg';

const images = {
avatar1,
avatar2,
avatar3,
avatar4,
avatar5,
avatar6,
avatar7,
avatar8,
avatar9,
avatar10,
avatar11,
bg1,
bg2,
bg3,
bg4,
bg5,
me,
me2,
dev,
NY,



};
export default images;
